<template>
      <div class="col-sm-4 col-12 app-border-top pr-md-4">

                <h6 class="font-weight-bold description-header mt-2">Top Platorms</h6>
               
            
                <div v-for="(platform,index) in platorms" :key="platform.name" class="pt-2 d-flex flex-nowrap justify-content-between align-items-center">
                  <div class="w-50" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                    <i :class="'text-' + getColor(index)" class="fas fa-circle nav-icon mr-2"></i>{{platform.name}}
                  </div>

                  <div class="progress progress-sm mr-2" style="width: 55%">
                    <div :class="'bg-' + getColor(index)" class="progress-bar" :style="{width: platform.percentage + '%'}"></div>
                  </div>

                  <div >{{platform.percentage + '%'}}</div>
                </div>
              </div>

</template>


<script>

export default {

  props: {
    platorms:{
    type: Array,
    require: true
    }
  },

  methods:{
  
    getColor(index){
      return [
        'success',
        'secondary',
        'danger',
        'default',
        'info',
        'warning',
      ][index]
    }



  },
  

}
</script>

<style scoped>

/* Medium Devices, Desktops */
@media only screen and (min-width : 992px) {
.app-border-right {
    border-right: 1px solid #dee2e6 !important;
}
}

 /* Extra Small Devices, Phones */ 
@media only screen and (max-width : 480px) {
  .app-border-top {
    border-top: 1px solid #dee2e6 !important;
    margin-top: 20px;
    padding-top: 20px;

}
}

</style>